import { TPlanningTab, TSearchPlanningTab } from '../planning.type'
import { useTranslation } from 'react-i18next'
import { CurecallTab, PlusRoundedIcon } from '@honestica/curecall-ui'
import { useSession } from 'src/providers/auth.provider'
import { AdminOnlyBadge } from 'src/components/admin-only-badge.component'
import { PlanningTabItem } from './planning-tab-item.component'
import { isAllPlanningTab } from '../planning-all-tab.util'

interface Props {
  sortedTabs: TPlanningTab[]
  allTab: TSearchPlanningTab
  currentTab: TPlanningTab | TSearchPlanningTab
  moveToTab: (tab: TPlanningTab | TSearchPlanningTab) => void
  addTab: VoidFunction
  updateTab: VoidFunction
  duplicateTab: VoidFunction
  deleteTab: VoidFunction
}

const PlanningTabs = ({
  sortedTabs,
  allTab,
  currentTab,
  moveToTab,
  addTab,
  updateTab,
  duplicateTab,
  deleteTab,
}: Props) => {
  const { t } = useTranslation()
  const { currentUser } = useSession()

  return (
    <nav className="c-flex c-border-b-2 c-border-b-grey-300 c-flex-wrap c-gap-3" data-planning-tour="tabs">
      {sortedTabs.map((tab, index) => (
        <PlanningTabItem
          key={`planning-tab-${tab.id}`}
          label={tab.label}
          isActive={currentTab.id === tab.id}
          onClick={() => moveToTab(tab)}
          onUpdate={updateTab}
          onDuplicate={duplicateTab}
          onDelete={deleteTab}
          menuClassName={index < 2 ? 'c-left-0 c-right-auto' : undefined}
        />
      ))}
      <PlanningTabItem
        label={t('pages.planning.all-tab')}
        isActive={isAllPlanningTab(currentTab)}
        onClick={() => moveToTab(allTab)}
        onUpdate={updateTab}
        onDuplicate={duplicateTab}
      />
      {currentUser?.isAdmin && (
        <CurecallTab onClick={addTab}>
          <AdminOnlyBadge />
          <PlusRoundedIcon className="c-w-3" />
          {t('pages.planning.add-tab')}
        </CurecallTab>
      )}
    </nav>
  )
}

export default PlanningTabs
